"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var config = {
  name: 'PTT',
  url: 'wss://ws.ptt.cc/bbs',
  charset: 'utf8',
  origin: 'app://pcman',
  protocol: 'websocket',
  timeout: 200,
  blobSize: 1024,
  preventIdleTimeout: 30,
  terminal: {
    columns: 80,
    rows: 24
  },
  numOfPagesPerIteration: 1
};
var _default = config;
exports["default"] = _default;